import React, {Component} from 'react';
import {connect} from 'react-redux';
import {appSetConfig} from 'store/app/actions';
import {availableLanguages} from 'locale/i18n';
import './LanguageSelector.scss';

class LanguageSelector extends Component {
  handleChange = (e) => {
    const { config, dispatch } = this.props;
    dispatch(appSetConfig({ ...config, lang: e.target.value }));
  };

  render() {
    const { config } = this.props;

    return (
      <div className="select-container">
        <select value={config.lang} onChange={this.handleChange}>
          {availableLanguages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default connect((state) => ({ config: state.app.config }))(LanguageSelector);
